import { TicketAttachmentUpload, TicketServiceData } from 'services/Tickets/ticketServiceType';
import { SortParams } from 'types/common/sorting';
import { FetchAction } from 'types/services/redux-action';
import { FetchReducer, SortState } from 'types/services/redux-state';

export const FETCH_TICKETS_IS_COMPLETE = 'FETCH_TICKETS';

export const FETCH_TICKETS_IS_PENDING = 'FETCH_TICKETS_IS_PENDING';

export const FETCH_TICKETS_IS_ERROR = 'FETCH_TICKETS_IS_ERROR';

export const FETCH_OPEN_OR_UNREAD_TICKETS = 'FETCH_OPEN_OR_UNREAD_TICKETS';

export const FETCH_OPEN_OR_UNREAD_TICKETS_IS_PENDING = 'FETCH_OPEN_OR_UNREAD_TICKETS_IS_PENDING';

export const FETCH_OPEN_OR_UNREAD_TICKETS_IS_ERROR = 'FETCH_OPEN_OR_UNREAD_TICKETS_IS_ERROR';

export const FILTER_TICKETS = 'FILTER_TICKETS';

export const FETCH_TICKET_BY_ID_IS_ERROR = 'FETCH_TICKET_BY_ID_IS_ERROR';

export const FETCH_TICKET_BY_ID_IS_PENDING = 'FETCH_TICKET_BY_ID_IS_PENDING';

export const FETCH_TICKET_BY_ID_IS_COMPLETE = 'FETCH_TICKET_BY_ID';

export const FETCH_ATTACHMENT_IS_ERROR = 'FETCH_ATTACHMENT_IS_ERROR';

export const FETCH_ATTACHMENT_IS_PENDING = 'FETCH_ATTACHMENT_IS_PENDING';

export const FETCH_ATTACHMENT_IS_COMPLETE = 'FETCH_ATTACHMENT';

export const TOGGLE_TICKET = 'TOGGLE_TICKET';

export const OPEN_TICKET_IS_PENDING = 'OPEN_TICKET_IS_PENDING';

export const OPEN_TICKET_IS_ERROR = 'OPEN_TICKET_IS_ERROR';

export const CLOSE_TICKET_IS_PENDING = 'CLOSE_TICKET_IS_PENDING';

export const CLOSE_TICKET_IS_ERROR = 'CLOSE_TICKET_IS_ERROR';

export const REPLY_TICKET = 'REPLY_TICKET';

export const REPLY_TICKET_IS_PENDING = 'REPLY_TICKET_IS_PENDING';

export const REPLY_TICKET_IS_ERROR = 'REPLY_TICKET_IS_ERROR';

export const SET_TICKET_ATTACHMENTS = 'SET_TICKET_ATTACHMENTS';

export const SORT_TICKETS = 'SORT_TICKETS';

export type TicketReducerState = {
  ticket: TicketServiceData | undefined;
  attachments: TicketAttachmentUpload[];
  tickets: TicketServiceData[];
  filterBy: string;
} & FetchReducer<'fetchTickets' | 'fetchTicketById' | 'fetchOpenOrUnreadTickets'> &
  SortState<TicketServiceData>;

export type TicketActions =
  | FetchAction<'FETCH_TICKETS', TicketServiceData[]>
  | FetchAction<'FETCH_TICKET_BY_ID', TicketServiceData>
  | FetchAction<'FETCH_OPEN_OR_UNREAD_TICKETS', TicketServiceData[]>
  | FetchAction<'FETCH_ATTACHMENT', string>
  | FetchAction<'OPEN_TICKET', unknown>
  | FetchAction<'CLOSE_TICKET', unknown>
  | FetchAction<'REPLY_TICKET', TicketServiceData>
  | FetchAction<'TICKET_CATEGEGORIES', TicketServiceData>
  | { type: 'SET_TICKET_ATTACHMENTS'; files: TicketAttachmentUpload[] }
  | { type: 'FILTER_TICKETS'; filterBy: string }
  | { type: 'SORT_TICKETS'; params: SortParams<TicketServiceData> }
  | { type: 'TOGGLE_TICKET' };
